import IFrameSignature from "./IFrameSignature";

export default IFrameSignature;



// WEBPACK FOOTER //
// ./src/components/IFrameSignature/index.js